<script setup lang="ts">

import FeaturePanel from './FeaturePanel.vue';
import GetTheAppButton from '@components/GetTheAppButton/GetTheAppButton.vue';

</script>

<template>

    <div class="max-w-5xl mx-auto px-4">
                
        <h1 class="text-4xl font-semibold text-center mt-8">
            We're there to keep your car running healthy
        </h1>
                
        <FeaturePanel>

            <template #image>
                <img src="@/assets/images/Screenshots/my-garage.png" class="w-4/5 md:w-full"/>
            </template>
          
            <template #headline>
               Healthy Car
            </template>          

            <div class="flex flex-col gap-4">
                <h1 class="text-2xl font-semibold pb-4">
                    Keep your car <span class="text-primary-600 uppercase font-bold">Healthy</span>  
                    <br>
                    with a range of vehicle benefits
                </h1>
            </div>

            <p class="mb-2">
                The Carbucks App takes all the guesswork out of keeping your car running smoothly
            </p>

            <p class="mb-2">
                Can't remember when your rego is due?  Carbucks remembers!  Got an orange light on your dashboard
                and don't know what it means?  Carbucks can help you with that!  We're there when you break down,
                when you have a chip in the windscreen, or when you need to get your annual service.
            </p>

            <p class="mb-8">
                Carbucks connects you to your car, and to all the services you need to keep your driving experience hassle free.
            </p>
            
            <GetTheAppButton />

        </FeaturePanel>
                
        <h1 class="text-4xl font-semibold text-center mt-8">
            More than just a healthy car
        </h1>
                
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 my-16">
            
            <!-- CHIP AND PUNCTURE REPAIR -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-automotive.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1"><strong>FREE</strong> Services To Keep Your Car Moving</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        In partnership with your dealership, Carbucks provides thse exclusive services that you can't get anywhere else:
                    </p>
                    <ul class="list-disc list-outside ml-4">
                        <li>
                            <strong class="text-emerald-500">FREE</strong> vehicle health checks ahead of those long trips
                        </li>
                    </ul>          
                </div>
            </div>

            <!-- HEALTH CHECKS -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-health-checks.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1"><strong>FREE</strong> Vehicle Health Checks</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        Going on a long road-trip, or want to get that strange noise checked out?
                    </p>
                    <p>
                        Get FREE vehicle health checks that gives all your car's essential components a look over
                        for any signs of trouble.
                    </p>
        
                </div>
            </div>

            <!-- AUTOMOTIVE PARTNERS -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-pick-up-and-delivery.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1">Exclusive Automotive Partners</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        Carbucks brings you exclusive deals and offers in Automotive that you can't get anywhere else.
                    </p>
                    <p>
                        Our partner network is extensive and growing and we make the deals on your behalf to keep your
                        running costs as low as possible.
                    </p>
                </div>
            </div>

            <!-- INSURANCE -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-insurance.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1">Vehicle Insurance</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        Our partners can bring you cheaper car insurance by 
                        tailoring your premium to your driving habits.
                    </p>
                    <p>
                        Safer, more responsible driving translates into lower costs, 
                        offering affordability and fairness in coverage
                    </p>
                </div>
            </div>

            <!-- TRIP LOGS -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-trip-log.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1">Trip Logs</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        The Carbucks app gives you trip logging ans implifies expense tracking,
                        with an accurate mileage record.  It streamlines financial management
                        and saves you time when driving is part of your business.
                    </p>
                </div>
            </div>

            <!-- CONCIERGE -->
            <div class="bg-gray-50 p-6 flex flex-col gap-y-4 rounded-lg">
                <img src="@/assets/images/HowItWorks/category-concierge.png" class="w-full" />
                <h1 class="text-2xl font-semibold mt-1">VIP Concierge</h1>
                <div class="flex flex-col gap-2">
                    <p>
                        Experience VIP treatment with our Carbucks Concierge.  Get realtime help and assistence and
                        quicker, one-to-one service for that valued customer experience.
                    </p>
                    <p>
                        Other apps will make you talk to their so-called 'AI' robots, but with Carbucks you 
                        speak with a person for that human experience!
                    </p>
                </div>
            </div>

        </div>

    </div>

</template>